import { alchemy, polygon } from '@account-kit/infra'
import { createConfig } from '@account-kit/react'
import { Connection } from '@solana/web3.js'

const SOLANA_RPC_URL = `https://solana-mainnet.g.alchemy.com/v2/${process.env.NEXT_PUBLIC_ALCHEMY_API_KEY}`

const SESSION_DURATION_MS = 1000 * 60 * 60 * 24 * 7

export const accountKitConfig = createConfig(
	{
		transport: alchemy({ apiKey: process.env.NEXT_PUBLIC_ALCHEMY_API_KEY ?? '' }),
		chain: polygon,
		ssr: true,
		enablePopupOauth: true,
		sessionConfig: {
			expirationTimeMs: SESSION_DURATION_MS,
		},
		solana: {
			connection: new Connection(SOLANA_RPC_URL, {
				commitment: 'confirmed',
			}),
			policyId: process.env.NEXT_PUBLIC_ALCHEMY_POLICY_ID,
		},
	},
	{
		auth: {
			sections: [[{ type: 'email' }]],
			addPasskeyOnSignup: false,
		},
	}
)
